import { useEffect, useRef, useState } from "react";

export default function useTrackPlayer(track) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setCurrentTime((t) => {
          if (t >= track.durationSeconds) {
            setIsPlaying(false);
            return 0;
          }
          return t + 1;
        });
      }, 1000);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPlaying, track.durationSeconds]);

  // Reset playback whenever the track itself changes (navigating to a new track page).
  useEffect(() => {
    setIsPlaying(false);
    setCurrentTime(0);
  }, [track.id]);

  const toggle = () => setIsPlaying((p) => !p);

  const seekTo = (seconds) => {
    setCurrentTime(Math.min(track.durationSeconds, Math.max(0, seconds)));
  };

  return { isPlaying, currentTime, toggle, seekTo };
}
